
define(
	'MHI.MHIShowFirstImage.Main'
,   [
		'Profile.Model',
		'ProductDetails.ImageGallery.View'
	]
,   function (
		ProfileModel,
		ProductDetailsImageGalleryView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			ProductDetailsImageGalleryView.prototype.initialize = _.wrap( ProductDetailsImageGalleryView.prototype.initialize, function (fn) {
				fn.apply(this, _.toArray(arguments).slice(1));

				var profile = ProfileModel.getInstance();
				this.images = this.model.getImages();
				
				if ( !profile.isLoggedIn() ) {
					this.images.length = 1;
				}
			});

		}
	};
});
